import * as React from 'react';
import {
  Button,
  Typography,
} from '@mui/material';
import analytics from '../../../utils/analytics';

interface SurveyCardProps {
  style?: React.CSSProperties;
}

const defaultProps = {
  style: {},
};

export default function SurveyCard(props: SurveyCardProps) {
  const { style } = props;

  const goToSurvey = () => {
    analytics.track('Click Boton', { text: 'Ayúdanos a mejorar', initiator: 'usuario' });
    window.open('https://docs.google.com/forms/d/1lgkyo3HRKgaE2bBcgwefBzfdZeD81lmsJZtEO_0uKyE');
  };

  return (
    <div style={style}>
      <Typography
        variant="h6"
        gutterBottom
      >
        ¿Tienes un minuto?
      </Typography>
      {' '}
      <Button
        variant="contained"
        style={{ maxWidth: '240px' }}
        onClick={goToSurvey}
      >
        Ayúdanos a mejorar
      </Button>
    </div>
  );
}

SurveyCard.defaultProps = defaultProps;
